import { createAction } from 'redux-actions';
import { ACTIONS } from '../const';

const { ADD_AURAL_NOTIFICATION, REMOVE_AURAL_NOTIFICATION } = ACTIONS;

export const addAural = createAction(ADD_AURAL_NOTIFICATION);
export const removeAural = createAction(REMOVE_AURAL_NOTIFICATION);



// WEBPACK FOOTER //
// ./src/actions/aural_notification.js